import React from 'react';

const Analytics = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Analytics Dashboard</h1>
      <p className="text-gray-600">Analytics coming soon...</p>
    </div>
  );
};

export default Analytics;